<style></style>

<template>
    <div class="assessments-dash-component">
        <section id="action-planning-get-ready" class="mb-5">
            <h2 class="lighter text-primary">Get Ready to Plan</h2>            
            <how-to-row>
                <template #left>
                    <how-to-video></how-to-video>
                </template>
                <template #right>
                    <print-dropdown icon="icon-book">
                        <template #trigger-label>
                                View the How-To Guide
                        </template>
                        <template #collapse-content>
                            <ul class="list-unstyled">
                                <li class="link-alternate"><a :href="$basePath+'/uploads/GNS_Provider_How_To_Guide_Action Planning (English Computer).pdf'" target="_blank">English Desktop</a></li>
                                <li class="link-alternate"><a :href="$basePath+'/uploads/GNS_Provider_How_To_Guide_Action Planning (Spanish Computer).pdf'" target="_blank">Español Desktop</a></li>
                                <li class="link-alternate"><a :href="$basePath+'/uploads/GNS_Provider_How_To_Guide_Action Planning (English Mobile).pdf'" target="_blank">English Mobile</a></li>
                                <li class="link-alternate"><a :href="$basePath+'/uploads/GNS_Provider_How_To_Guide_Action_Planning_Mobile Spanish.pdf'" target="_blank">Español Mobile</a></li>
                            </ul>
                        </template>
                    </print-dropdown>
                </template>
            </how-to-row>
        </section>

        <section class="mb-3">
            <h2 class="lighter text-primary">Select Goals &amp; Create Action Plans</h2>
            <dashboard-tabs :modules="modules">
                <template #primary="{ module }">
                    <primary-block>
                        <template #step>
                            <span class="five-steps-number two float-left"></span>
                            <h3 class="lighter text-orange">
                                Plan
                            </h3>
                            <p>Use self-assessment results to select goals and create action plans.</p>
                        </template>
                        <template #action>
                            <p>
                                Status: <strong>{{getPlanningStatus(module)}}</strong>
                            </p>
                        <div class="action-link pt-1" v-if="plansInModule(module.id).length < 1 || (actionLinkLabel(module) !== null && actionUrl(module) !== null)">
                                <a :href="actionUrl(module)" class="btn btn-orange-blue text-white">
                                    {{actionLinkLabel(module)}}
                                </a>
                            </div>
                        </template>
                    </primary-block>
                </template>
                <template #secondary="{ module }">
                    <div v-if="plansInModule(module.id).length > 0" :class="'border-'+ module.color" class="mx-0 p-4 border-top-0">
                        <h2 class="lighter mb-0">Create or Update Action Plan</h2>
                        <action-plan-list :module="module" :action-plans="plansInModule(module.id)" :assessments="[]"></action-plan-list>
                        <div class="select-additional mt-4">
                            <a :href="moduleSelectGoalsLink(module)" class="btn btn-orange-blue btn-sm text-white" style="width: 200px"><strong>Select Additional Goals</strong></a>
                        </div>
                    </div>
                </template>
            </dashboard-tabs>
        </section>
    </div>
</template>

<script>
    import DashboardTabs from '../dashboard_tabs/DashboardTabs'
    import PrimaryBlock from '../dashboard_tabs/PrimaryBlock'
    import ActionPlanList from '../action_plans/ActionPlanList'
    import HowToRow from '../../components/HowToRow'
    import HowToVideo from '../../components/HowToVideo'
    import PrintDropdown from '../../components/PrintDropdown'
    
    import moment from 'moment'


    export default {
        components: {
            DashboardTabs,
            PrimaryBlock,
            ActionPlanList,
            HowToRow,
            HowToVideo,
            PrintDropdown
        },
        props: {
            program: {
                required: true,
                type: Object
            },
            actionPlans: {
                required: true,
                type: Array
            },
            modules: {
                required: true,
                type: Array
            },
            assessments: {
                required: true,
                type: Array
            }
        },
        data() {
            return {
            }
        },
        methods: {
            getPlanningStatus(module) {
                const moduleAssessments = this.assessmentsInModule(module)
                if (this.plansInModule(module.id).length == 0) {
                    if (moduleAssessments.length == 0) {
                        return 'Not Started'
                    } else if (this.finishedAssessments(module).length > 0) {
                        const lastAsmnt = this.finishedAssessments(module).pop();
                        return 'Self-Assessment Completed '+moment(lastAsmnt.finalized_at).format('MM/DD/YYYY')
                    } else {
                        return 'Not Started';   
                    }
                }
                return 'In Progress'
            },
            actionUrl(module) {
                const moduleAssessments = this.assessmentsInModule(module);
                if (this.plansInModule(module.id).length == 0) {
                    if (moduleAssessments.length == 0) {
                        return this.$basePath+'/self-assessments/intro/'+module.slug;
                    }
                }

                if (this.finishedAssessments(module).length == 0) {
                    return this.$basePath+'/self-assessments/'+module.slug+'/'+moduleAssessments.slice(-1)[0].id;
                }
                if (this.startedPlans(module.id).length == 0) {
                    return this.moduleSelectGoalsLink(module)
                }
                return null

            },
            actionLinkLabel(module) {
                const moduleAssessments = this.assessmentsInModule(module);
                if (this.plansInModule(module.id).length == 0) {
                    if (moduleAssessments.length == 0 || this.finishedAssessments(module).length == 0) {
                        return 'Complete Self-Assessment';
                    }
                    return 'Select Goals';
                }
                return null

            },
            finishedAssessments(module) {
                const moduleAssessments = this.assessmentsInModule(module)
                return moduleAssessments.filter(assmnt => assmnt.finalized_at !== null)
            },
            plansInModule(moduleId) {
                if (this.actionPlans) {
                    return this.actionPlans.filter((ap) => {
                        return ap.goal.best_practice.module_id == moduleId
                    });
                }
                return [];
            },
            assessmentsInModule(module) {
                if (this.assessments) {
                    return this.assessments.filter(asmnt => {
                        return asmnt.survey.module_id == module.id
                    })
                }
                return [];
            },
            latestAssessmentInModule(module) {
                return this.finishedAssessments(module).slice(-1)[0];
            },
            moduleSelectGoalsLink(module) {
                if (this.finishedAssessments(module).length > 0) {
                    return this.$basePath+'/action-plans/'+this.latestAssessmentInModule(module).survey.slug+'/'+this.latestAssessmentInModule(module).id+'/select-sections';
                }
                return '#'
            },
            startedPlans(moduleId) {
                return this.plansInModule(moduleId).filter( ap => ap.date_started !== null);
            },
            finishedPlans(moduleId) {
                return this.startedPlnas(moduleId).filter( ap => ap.date_completed !== null);
            },
        },
    
}
</script>